import { AppNavigationConfig, AppNavigationConfigItem } from '@/types/ssr';

export type UseFullPagesConfigItem = {
  link: string;
  label: string;
};

export const makeUsefulPagesConfig = (pages: AppNavigationConfig) => {
  const makeUsefulElement = ({ name, path }: AppNavigationConfigItem) => ({
    label: name,
    link: path,
  });

  return pages.map(makeUsefulElement);
};
